<template>
  <Popover ref="rateListPopover" placement="auto" :scrollable="true">
    <ul class="dropdown-menu-popover">
      <template v-if="isRateVariation">
        <DropdownMenuItem icon="fa-trash-alt" label="Remove Rate Variation" @click="removeSalesRateVariation">Remove Rate Variation</DropdownMenuItem>
        <DropdownMenuDivider />
      </template>
      <DropdownMenuItem 
        v-for="salesRate in pricingSalesRateList"
        :key="`rate-${salesRate.id}`"
        :icon="salesRateIcon(salesRate)"
        iconStyle="fas"
        :label="salesRate.name"
        class="my-3"
        @click="applySalesRate(salesRate)">
        <span class="font-weight-bold mr-4">{{salesRate.name}}</span> <span class="float-right" v-if="showPricing">{{calculateRatePrice(salesRate) | formatCurrency}}</span>
      </DropdownMenuItem>
    </ul>
  </Popover>
</template>


<script>
import { round } from 'mathjs'

import Popover from '@/components/popover'
import CustomerPriceListMixin from '@/modules/pricing/mixins/customerPriceListMixin.js'

export default {
  name: 'StockPriceListRatePopover',
  mixins: [CustomerPriceListMixin],
  components: {
    Popover
  },
  props: {
    pricingSalesRateList: Array,
    showPricing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      stockSalesPrice: 0,
      stockId: null,
      stockCategoryId: null,
      selectedSalesRateId: null,
      stockPriceGroupId: null,
      serviceRangeId: null,
      isRateVariation: false
    }
  },
  methods: {
    displayPriceSelectionFromElement(el, stockId, stockPriceGroupId, serviceRangeId, selectedSalesRateId, stockSalesPrice = 0.0, isRateVariation = false) {
      this.stockId = stockId
      this.stockCategoryId = null
      this.stockPriceGroupId = stockPriceGroupId
      this.serviceRangeId = serviceRangeId
      this.selectedSalesRateId = selectedSalesRateId
      this.stockSalesPrice = stockSalesPrice
      this.isRateVariation = isRateVariation

      this.$refs.rateListPopover.displayFromElement(el)
    },
    displayCategorySelectionFromElement(el, stockCategoryId, stockPriceGroupId, serviceRangeId, selectedSalesRateId) {
      this.stockId = null
      this.stockCategoryId = stockCategoryId
      this.stockPriceGroupId = stockPriceGroupId
      this.serviceRangeId = serviceRangeId
      this.selectedSalesRateId = selectedSalesRateId
      this.stockSalesPrice = 0
      this.isRateVariation = false

      this.$refs.rateListPopover.displayFromElement(el)
    },
    calculateRatePrice(salesRate) {
      return parseFloat(this.stockSalesPrice) + parseFloat(this.stockSalesPrice) * round(parseFloat(salesRate.percentAdjust) / 100.0, 2)
    },
    applySalesRate(salesRate) {
      if(this.stockId) {
        this.$emit('applyStockRate', {
          stockId: this.stockId,
          salesRateId: salesRate.id,
          stockPriceGroupId: this.stockPriceGroupId,
          serviceRangeId: this.serviceRangeId
        })
      } else if(this.stockCategoryId) {
        this.$emit('applyCategoryRate', {
          stockCategoryId: this.stockCategoryId,
          salesRateId: salesRate.id,
          stockPriceGroupId: this.stockPriceGroupId,
          serviceRangeId: this.serviceRangeId
        })
      }
      this.$refs.rateListPopover.hidePopover()
    },
    removeSalesRateVariation() {
      this.$emit('removeStockRateVariation', {
        stockId: this.stockId,
        stockPriceGroupId: this.stockPriceGroupId,
        serviceRangeId: this.serviceRangeId
      })
      this.$refs.rateListPopover.hidePopover()
    }
  }
}
</script>